module.exports = __webpack_public_path__ + "static/media/weather.6da58429.jpg";